<template>
  <a-dropdown
    class="filter-options-dropdown"
    :trigger="['click', 'contextmenu']"
    :get-popup-container="(node) => node.parentElement"
    placement="bottomLeft"
  >
    <div class="filter-options-dropdown__icon">
      <img src="@/components/profile/assets/more_vertical.svg" alt="" />
    </div>
    <template #overlay>
      <a-menu class="filter-options-dropdown__menu">
        <a-menu-item
          class="filter-options-dropdown__menu-item"
          @click.stop="showForm"
        >
          <img
            src="@/components/projects/components/icons/assets/material-export.svg"
            alt=""
          />
          <span>Экспорт</span>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <drawer-right v-model="isShowForm" @close="onDrawerClose">
    <project-export-form :search-params="searchParams" @close="onDrawerClose" />
  </drawer-right>
</template>

<script setup>
  import { ref } from 'vue';
  import DrawerRight from '@/components/drawers/components/DrawerRight.vue';
  import ProjectExportForm from '@/components/projects/components/ProjectExportForm.vue';

  defineProps({
    searchParams: Object,
  });

  const isShowForm = ref(false);

  const showForm = () => {
    isShowForm.value = true;
  };

  const onDrawerClose = () => {
    isShowForm.value = false;
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .filter-options-dropdown__icon {
    background-color: $color-bg-primary-white;
    border-radius: 5px;
    cursor: pointer;
    height: 30px;
    padding: 3px;
    right: 40px;
    width: 30px;
  }

  .filter-options-dropdown__menu {
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 10px;
    z-index: auto;

    .filter-options-dropdown__menu-item {
      display: flex;
      flex-direction: row;
      justify-content: center;

      .ant-dropdown-menu-title-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
      }

      img {
        height: 24px;
        width: 24px;
        margin-bottom: 4px;
      }

      span {
        font: 700 16px/26px 'Nunito Sans';
        color: $color-text-secondary-1;
        margin-left: 14px;
      }

      button {
        background: $color-btn-primary-disabled;

        &:hover {
          background-color: $color-btn-primary-disabled;
        }
      }
      button.ant-switch-checked {
        background: $color-btn-primary;

        &:hover {
          background-color: $color-btn-special-hover;
        }
      }
    }

    .filter-options-dropdown__menu-item.ant-dropdown-menu-item-disabled {
      span:last-child {
        color: $color-text-secondary-grey;
      }
    }
  }
</style>
